import { signal } from '@angular/core';

const PAIRING_CODE_KEY = 'sumup-dev-pairing-code';
const READER_ID_KEY = 'sumup-dev-reader-id';

const revision = signal(0);

export class SumUpDevReader {
  static revision(): number {
    return revision();
  }

  static pairingCode(): string {
    return sessionStorage.getItem(PAIRING_CODE_KEY)?.trim() ?? '';
  }

  static readerId(): string {
    return sessionStorage.getItem(READER_ID_KEY)?.trim() ?? '';
  }

  static setPairingCode(value: string): void {
    const code = value.trim();
    if (code) {
      sessionStorage.setItem(PAIRING_CODE_KEY, code);
    } else {
      sessionStorage.removeItem(PAIRING_CODE_KEY);
    }

    sessionStorage.removeItem(READER_ID_KEY);
    revision.update(value => value + 1);
  }

  static rememberReader(readerId: string): void {
    sessionStorage.setItem(READER_ID_KEY, readerId);
    sessionStorage.removeItem(PAIRING_CODE_KEY);
    revision.update(value => value + 1);
  }
}
